import { FormGroup } from '@angular/forms';
var TabPreferencesComponent = /** @class */ (function () {
    function TabPreferencesComponent() {
    }
    return TabPreferencesComponent;
}());
export { TabPreferencesComponent };
